exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.split[data-v-510e8fd8] {\n  width: 50%;\n}\n.flex[data-v-510e8fd8] {\n  align-items: center;\n}\n", ""]);

// exports
